// components
import { List } from '@mui/material';
import { Dialog } from 'components/shared/index';
import ShortcutsRow from './components/ShortcutsRow';

// hooks
import { useTranslation } from 'react-i18next';

// types
import { ShortcutsDialogProps } from './ShortcutDialog.types';

const ShortcutsDialog = ({ onClose, shortcuts }: ShortcutsDialogProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  return (
    <Dialog
      open
      maxWidth="medium"
      title={t('shortcuts.title')}
      handleClose={onClose}
    >
      <List>
        {Object.values(shortcuts)
          .filter(({ hidden }) => !hidden)
          .map(
            (
              { label = '', description = '', activatorKey, controllerKeys },
              index: number
            ) => (
              <ShortcutsRow
                key={index}
                primary={label}
                secondary={description}
                keys={[...controllerKeys, activatorKey]}
              />
            )
          )}
      </List>
    </Dialog>
  );
};

export default ShortcutsDialog;
